export default function indexVariablesByName(variables) {
  const safeVariables = variables || [];

  return safeVariables.reduce((index, { name, ...rest }) => (
    (index[name] = { name, ...rest }) && index
  ), {});
}
